import { render, staticRenderFns } from "./case_content.vue?vue&type=template&id=1dcf849c&scoped=true&"
import script from "./case_content.vue?vue&type=script&lang=js&"
export * from "./case_content.vue?vue&type=script&lang=js&"
import style0 from "./case_content.vue?vue&type=style&index=0&id=1dcf849c&lang=scss&scoped=true&"
import style1 from "./case_content.vue?vue&type=style&index=1&land=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf849c",
  null
  
)

export default component.exports